// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

// Turbo Frameのリダイレクト処理のみ残す
document.addEventListener('turbo:before-fetch-response', (event) => {
  if(event.detail.fetchResponse.header('X-Turbo-Connect') && typeof (event.detail.fetchResponse) !== 'undefined') {
    var response = event.detail.fetchResponse.response
    if (response.redirected) {
      event.preventDefault()
      Turbo.visit(response.url, {action: 'replace'})
    }
  }
})

document.addEventListener("turbo:click", (event) => {
  if (event.target.closest('a[href^="#"]')) event.preventDefault()
})

document.addEventListener("click", function(event) {
  if(event.target.matches("input[type=submit], button[type=submit]")) {
    const now = Date.now();

    const lastSubmitAt = event.target.dataset.lastSubmitAt
      ? parseInt(event.target.dataset.lastSubmitAt, 10)
      : 0;

    if (now - lastSubmitAt < 1000) {
      console.log('submit')
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.target.dataset.lastSubmitAt = now;
  }
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered:', registration);
      })
      .catch(error => {
        console.log('Service Worker registration failed:', error);
      });
  });
}
